/** Powered by @ttoss/config. https://ttoss.dev/docs/modules/packages/config/ */

// tsup.inject.js
import * as React from "react";

// src/useScript.ts
import * as React2 from "react";
var useScript = (src) => {
  const [status, setStatus] = React2.useState(
    src ? "loading" : "idle"
  );
  React2.useEffect(
    () => {
      if (!src) {
        setStatus("idle");
        return;
      }
      let script = document.querySelector(
        `script[src="${src}"]`
      );
      if (!script) {
        script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.setAttribute("data-status", "loading");
        document.body.appendChild(script);
        const setAttributeFromEvent = (event) => {
          if (script) {
            script.setAttribute(
              "data-status",
              event.type === "load" ? "ready" : "error"
            );
          }
        };
        script.addEventListener("load", setAttributeFromEvent);
        script.addEventListener("error", setAttributeFromEvent);
      } else {
        setStatus(
          script.getAttribute("data-status") || "error"
        );
      }
      const setStateFromEvent = (event) => {
        setStatus(event.type === "load" ? "ready" : "error");
      };
      script.addEventListener("load", setStateFromEvent);
      script.addEventListener("error", setStateFromEvent);
      return () => {
        if (script) {
          script.removeEventListener("load", setStateFromEvent);
          script.removeEventListener("error", setStateFromEvent);
        }
      };
    },
    [src]
  );
  return { status };
};
export {
  useScript
};
